<!--
  `hasMultipleProfiles` é o input do design-system que governa a VISIBILIDADE do controle de troca de
  perfil (repassado daqui ao user-popover). A condição ligada nele agora inclui a trava do CA04, por
  isso ele recebe `canSwitchProfile()` e não `hasMultipleProfiles()` — reverter faz o controle voltar
  a aparecer na sessão personificada. O rename foi adiado e está registrado como dívida no README.md, seção
  "Dívida Arquitetural Conhecida" (entrada `hasMultipleProfiles`), com as condições para fazê-lo.
-->
<lkt-sidebar-menu
  [isCollapsed]="isCollapsed()"
  [logoSrc]="resolvedLogoSrc()"
  [logoAlt]="logoAlt()"
  [logoRoute]="logoRoute()"
  [menuItems]="visibleMenuItems()"
  [helpMenuItems]="helpMenuItems()"
  [userPopoverItems]="userPopoverItems()"
  [userName]="userName()"
  [userAvatar]="userAvatar()"
  [profileLabel]="profileLabel()"
  [profileIcon]="profileIcon()"
  [hasMultipleProfiles]="canSwitchProfile()"
  [version]="appVersion()"
  [showViewSwitch]="showViewSwitch()"
  [viewSwitchSegments]="viewSwitchSegments"
  [viewSwitchActiveId]="viewSwitchActiveId()"
  [showNotifications]="showNotifications()"
  [notificationsUnreadLabel]="notificationsUnreadLabel()"
  [notificationsAriaLabel]="notificationsAriaLabel()"
  [notificationsOpen]="notificationsOpen()"
  [notificationsRingToken]="notificationsRingToken()"
  (toggleSidebar)="closeSidebar()"
  (popoverItemClick)="onPopoverItemClick($event)"
  (switchProfileClick)="onSwitchProfile()"
  (helpMenuExpand)="onHelpMenuExpand()"
  (viewSwitchClick)="onViewSwitchClick($event)"
  (notificationsClick)="onNotificationsClick($event)"
  (userPopoverVisibleChange)="$event && onHelpMenuExpand()"
  [attr.data-cy]="dataCy()" />
